import { atom } from "recoil";

export type ConceptNoteSection =
  | "concernAndGoal"
  | "intermediate"
  | "core"
  | "experience"
  | undefined;

export const selectedConceptNoteSectionAtom = atom<ConceptNoteSection>({
  key: "selectedConceptNoteSection",
  default: undefined,
});
